module.exports = {
    'AcceptedFunctional': 'C0003:1',
    'AcceptedPerformance': 'C0002:1',
    'AcceptedStrictlyNecessary': 'C0001:1',
    'AcceptedTargeting': 'C0004:1'
};